import * as _ from 'lodash';
import * as types from './types';

export const withdrawInitialState = {
  loading: false,
  error: null,
  successMessage: null,
};

export default (state = withdrawInitialState, action) => {
  switch (action.type) {
    case types.ACCOUNT_SETUP_WITHDRAW_SUCCESS:
      return {
        ...state,
        successMessage: action.payload,
      };

    case types.ACCOUNT_SETUP_WITHDRAW_FAIL:
      if (_.has(action.payload, 'response.data')) {
        const error = action.payload.response.data.Errors[0];

        return {
          ...state,
          error,
        };
      }

      return {
        ...state,
        error: {
          Title: 'Error',
          Message:
            'An error occurred while attempting to withdraw student. Please try again',
        },
      };

    case types.ACCOUNT_SETUP_WITHDRAW_CLEAR:
      return { ...withdrawInitialState };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/withdraw/reducer.js